import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    color: 'white',
    mb: '0',
    border: 'none',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'gray.400',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'white',
    },
    _focus: {
      '&&': {
        bg: 'beta.900',
        _placeholder: {
          color: 'gray.400',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'white',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.700',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
    sx: {
      '&&': {
        bg: 'blackAlpha.400',
        pb: '1',
        _placeholder: {
          color: 'whiteAlpha.700',
        },
      },
    },
  },
  inputRightIcon: {
    sx: {
      color: 'gamma.400',
      boxSize: '4',
    },
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: {
    alignItems: 'center',
    gap: 2,
    flex: 1,
    textAlign: 'left',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  accordionButtonIconSvg: {
    sx: {
      color: 'beta.300',
      fontSize: 'md',
    },
  },
  accordionButtonText: {
    fontSize: 'md',
    fontWeight: 'normal',
    color: 'white',
    fontFamily: 'Staatliches',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
  accordionButtonInnerIcon: {
    sx: {
      pos: 'absolute',
      right: '0',
      boxSize: '6',
      color: 'alpha.400',
    },
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
